<template lang="pug">
div
  v-toolbar(class="red" dark fixed)
    v-btn(icon to="/boletins")
      v-icon mdi-arrow-left
    v-toolbar-title {{titulo}}
    v-spacer
    v-btn(icon @click="botaoLimpar" v-if="exibeBotaoLimpar")
      v-icon mdi-close
    v-btn(icon @click="botaoSalvar" :loading="exibeLoadingBotaoSalvar")
      v-icon mdi-content-save
</template>

<script>
export default {
  name: 'toolbar-form-boletim',
  props: {
    titulo: String,
    exibeBotaoLimpar: {
      type: Boolean,
      default: false
    },
    exibeLoadingBotaoSalvar: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    botaoVoltar(){
      this.$emit('evento-voltar')
    },

    botaoSalvar(){
      this.$emit('evento-salvar')
    },

    botaoLimpar(){
      this.$emit('evento-limpar')
    }
  }
}
</script>
